import Hls from 'hls.js';
import { useSoundStore } from 'services/SoundService';
import { isIOS, isTablet } from 'mobile-device-detect';

const canPlayAudio = !(isIOS || isTablet);

import {
  AdditiveBlending,
  Color,
  LinearFilter,
  LinearMipmapNearestFilter,
  MeshBasicMaterial,
  NearestFilter,
  sRGBEncoding,
  TextureLoader,
  VideoTexture,
} from 'three';

export const createVideo = (videoSrc, position, isAuditorium) => {
  const video = document.createElement('video');
  video.setAttribute('playsinline', '');
  video.setAttribute('autoplay', '');
  video.setAttribute('loop', '');
  video.setAttribute('muted', '');
  video.autoplay = true;
  video.loop = true;
  video.playsinline = true;
  video.muted = true;
  video.crossOrigin = 'anonymous';

  if (!videoSrc) return video;

  let hls = null;
  if (videoSrc.endsWith('m3u8')) {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (Hls.isSupported() && !isSafari) {
      hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        useSoundStore.getState().playVideo(video, position);
      });
      hls.on(Hls.Events.ERROR, e => {
        // eslint-disable-next-line no-console
        console.log('ERROR', e);
      });
      video.play();
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoSrc;
      video.addEventListener('loadedmetadata', () => {
        video.play();
        if (isAuditorium && canPlayAudio) {
          useSoundStore.getState().playVideo(video, position);
        }
      });
    }
  } else {
    video.src = videoSrc;
    video.addEventListener('loadedmetadata', () => {
      video.play();
      if (isAuditorium) {
        useSoundStore.getState().playVideo(video, position);
      }
    });
  }

  return { video, hls };
};

function createDisplayMaterial(texture) {
  const material = new MeshBasicMaterial({ map: texture });
  material.color = new Color(0xffffff);

  texture.anisotropy = 16;
  texture.encoding = sRGBEncoding;
  texture.magFilter = LinearFilter;
  texture.flipY = false;

  //fastest
  // texture.generateMipmaps = false;
  // texture.minFilter = NearestFilter;

  //fast
  texture.generateMipmaps = false;
  texture.minFilter = LinearFilter;

  //nice
  // texture.generateMipmaps = true;
  // texture.minFilter = LinearMipmapNearestFilter;

  return material;
}

export const createVideoMaterial = (url, position, isAuditorium) => {
  const { video, hls } = createVideo(url, position, isAuditorium);
  const texture = new VideoTexture(video);

  const material = createDisplayMaterial(texture);
  material.addEventListener('dispose', () => {
    useSoundStore.getState().removeVideo(video);
    video.pause();
    texture.dispose();
    if (hls) {
      hls.detachMedia();
      hls.destroy();
    }
  });
  return { material, video };
};

export const createImageMaterial = url => {
  const texture = new TextureLoader().load(url);
  const material = createDisplayMaterial(texture);
  material.map.generateMipmaps = true;
  material.map.minFilter = LinearMipmapNearestFilter;
  material.transparent = true;
  return { material };
};
